module.exports = __webpack_public_path__ + "b739e64555d363ba0d37efc618a078f1.png";